// Growem — auth gate. Email/password via Supabase Auth. Dark, single-purpose.

import { useState } from 'react'
import { useStore } from '../state/store'
import { hasSupabaseConfig } from '../lib/supabase'

export default function Auth() {
  const { signIn, signUp } = useStore()
  const [mode, setMode] = useState<'in' | 'up'>('in')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [busy, setBusy] = useState(false)
  const [msg, setMsg] = useState<string | null>(null)

  if (!hasSupabaseConfig) {
    return (
      <div style={wrap}>
        <Brand />
        <div className="card" style={{ marginTop: 24, maxWidth: 360 }}>
          <div className="kick">configuración pendiente</div>
          <p className="tip" style={{ marginTop: 8 }}>
            Falta conectar Supabase. Define <code>VITE_SUPABASE_URL</code> y{' '}
            <code>VITE_SUPABASE_ANON_KEY</code> en el entorno y recarga.
          </p>
        </div>
      </div>
    )
  }

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    setBusy(true); setMsg(null)
    const fn = mode === 'in' ? signIn : signUp
    const { error } = await fn(email.trim(), password)
    setBusy(false)
    if (error) setMsg(error)
    else if (mode === 'up') setMsg('Cuenta creada. Si pide confirmación, revisa tu correo; si no, ya entraste.')
  }

  return (
    <div style={wrap}>
      <Brand />
      <p className="muted" style={{ fontSize: 14, marginTop: 10, maxWidth: 320, textAlign: 'center' }}>
        Nadie va a venir a hacerlo por ti. Entra y sigue el sistema.
      </p>
      <form onSubmit={submit} className="card" style={{ marginTop: 24, width: '100%', maxWidth: 360, display: 'flex', flexDirection: 'column', gap: 12 }}>
        <input style={inp} type="email" autoComplete="email" placeholder="correo" value={email} onChange={(e) => setEmail(e.target.value)} required />
        <input style={inp} type="password" autoComplete={mode === 'in' ? 'current-password' : 'new-password'} placeholder="contraseña" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={mode === 'up' ? 8 : 6} />
        <button className="btn" type="submit" disabled={busy}>{busy ? '…' : mode === 'in' ? 'Entrar' : 'Crear cuenta'}</button>
        {msg && <div className="tip" style={{ color: 'var(--warn)' }}>{msg}</div>}
        <button type="button" className="link" style={{ fontSize: 13, background: 'none', padding: 0 }} onClick={() => { setMode(mode === 'in' ? 'up' : 'in'); setMsg(null) }}>
          {mode === 'in' ? '¿No tienes cuenta? Crear una' : '¿Ya tienes cuenta? Entrar'}
        </button>
      </form>
    </div>
  )
}

function Brand() {
  return <div className="disp" style={{ fontWeight: 700, fontSize: 40 }}>growem<span style={{ color: 'var(--volt)' }}>.</span></div>
}

const wrap: React.CSSProperties = {
  minHeight: '100dvh', display: 'flex', flexDirection: 'column', alignItems: 'center',
  justifyContent: 'center', padding: 24,
}
const inp: React.CSSProperties = {
  background: 'var(--surface-2)', border: '1px solid var(--line-12)', borderRadius: 'var(--r-sm)',
  padding: '12px 14px', fontSize: 15, outline: 'none', width: '100%',
}
